import {
  api,
  apiRequest,
  AUTH_ROLE_KEY,
  AUTH_STATUS_KEY,
  AUTH_TOKEN_KEY,
  AUTH_USERNAME_KEY,
  clearAuthSession,
  hasValidAuthToken,
} from "./apiClient";
import { notifyAuthSessionChanged, saveSessionProfile } from "./sessionProfile";

export const isAuthenticated = () => hasValidAuthToken();

export const login = async ({ username, password }) => {
  const result = await api.post("/api/auth/login", { username, password });
  if (!result?.token) throw new Error("Backend không trả về token");
  localStorage.setItem(AUTH_TOKEN_KEY, result.token);
  localStorage.setItem(AUTH_USERNAME_KEY, result.username || username);
  if (result.role) localStorage.setItem(AUTH_ROLE_KEY, result.role);
  if (result.status) localStorage.setItem(AUTH_STATUS_KEY, result.status);
  saveSessionProfile(result);
  notifyAuthSessionChanged();
  return result;
};

export const refreshSessionProfile = async () => {
  return api.get("/api/auth/me");
};

export const publishSessionProfile = (profile) => {
  if (profile?.username) localStorage.setItem(AUTH_USERNAME_KEY, profile.username);
  if (profile?.role) localStorage.setItem(AUTH_ROLE_KEY, profile.role);
  if (profile?.status) localStorage.setItem(AUTH_STATUS_KEY, profile.status);
  return saveSessionProfile(profile);
};

export const sendOtp = (email) => apiRequest(`/api/auth/send-otp?email=${encodeURIComponent(email)}`, { method: "POST" });

export const register = (values) => api.post("/api/auth/register", { ...values, userType: "USER" });

export const logout = () => clearAuthSession();
